import React from "react";
import Header from "../components/Header";
import Table from "../components/payroll/Table";

function PayrollHeaderItem({ text, number, active }) {
  return (
    <div
      className={`${
        active && " border-pink-500 "
      } w-full flex items-start md:items-center justify-start space-x-1 px-1 sm:px-2 border-b-4 pb-3 cursor-pointer`}
    >
      <div
        style={{ minWidth: "20px", minHeight: "20px" }}
        className="rounded-full bg-gradient-to-tr from-pink-500 to-pink-600 text-white text-xs shadow-lg flex items-center justify-center"
      >
        {number}
      </div>
      <span className="text-sm">{text}</span>
    </div>
  );
}

const Payroll = ({ LeftNavRef }) => {
  return (
    <div className="w-full px-4 md:px-10 pb-10">
      <Header LeftNavRef={LeftNavRef} />
      <h2 className="text-lg mb-4">Payroll Overview</h2>
      <div className="flex justify-between items-center space-x-5 sm:pr-5 md:pr-10">
        <h4 className="text-base font-normal">
          Agile Payroll Process Guideline
        </h4>
        <div className="flex flex-col items-start">
          <button className="w-36 py-1 bg-gray-200 mb-2 shadow-xl rounded-md">
            Payroll on track
          </button>
          <small className="w-36 text-center -mt-2">Nothing to do here</small>
        </div>
      </div>

      <div className="flex justify-between overflow-x-auto w-full my-6 px-1">
        <PayrollHeaderItem active={true} number="1" text="Payroll Approval" />
        <PayrollHeaderItem number="2" text="Payroll Submitted" />
        <PayrollHeaderItem number="3" text="Agile Processing" />
        <PayrollHeaderItem number="4" text="Employees Paid" />
      </div>

      <button className="py-2 px-5 rounded bg-gradient-to-r text-white from-[#EE5397] to-[#BA004F] ">
        Ongoing Payroll
      </button>

      <Table />
    </div>
  );
};

export default Payroll;
